module.exports = __webpack_public_path__ + "static/media/tear.e7e8c279.mp3";